import { FeedbackEvent } from './types';

interface BaseEvent {
  workspace_id: string;
  actor_user_id: string;
  ui_surface: 'dashboard';
  timestamp: string;
}

function makeBase(): BaseEvent {
  return {
    workspace_id: 'mock-workspace-001',
    actor_user_id: 'mock-user-001',
    ui_surface: 'dashboard',
    timestamp: new Date().toISOString(),
  };
}

export function emitEvent(type: string, payload: Record<string, unknown>): void {
  const event = { ...makeBase(), ...payload };
  console.log('[niwt:event]', type, event);
}

export function emitDecisionApprove(decision_id: string, agent_id: string): void {
  emitEvent('decision.approve', { decision_id, agent_id });
}

export function emitDecisionDelegate(decision_id: string, to_agent_id: string): void {
  emitEvent('decision.delegate', { decision_id, to_agent_id });
}

export function emitDecisionReject(feedback: FeedbackEvent): void {
  emitEvent('decision.reject', { feedback });
}

export function emitDecisionSnooze(decision_id: string): void {
  emitEvent('decision.snooze', { decision_id, snooze_until: null });
}

export function emitDecisionOpenReceipts(decision_id: string): void {
  emitEvent('decision.open_receipts', { decision_id });
}

export function emitDraftOpen(draft_id: string): void {
  emitEvent('draft.open', { draft_id });
}

export function emitNiwtAsk(agent_id: string): void {
  emitEvent('niwt.ask', { agent_id, context: null });
}

export function emitNiwtDraft(agent_id: string): void {
  emitEvent('niwt.draft', { agent_id, context: null });
}

export function emitNiwtFollowUp(agent_id: string): void {
  emitEvent('niwt.follow_up', { agent_id, context: null });
}

export function emitNiwtPrepMeeting(agent_id: string): void {
  emitEvent('niwt.prep_meeting', { agent_id, context: null });
}
